import React, { PureComponent } from 'react';
import { withStyles } from '@lifeomic/chroma-react/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { contextKeys } from '../../../../../redux/modules/asyncRequestContexts';
import { fhirActions } from '../../../../../redux/modules/fhir';
import { bindContextKeyToSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/asyncRequestContexts/selectors';
import { defineMessages, injectIntl } from 'react-intl';
import { asyncRequestContextsActions } from '@lifeomic/phc-web-toolkit/src/redux/modules/asyncRequestContexts';
import PropTypes from 'prop-types';
import NotificationHelper from '@lifeomic/phc-web-toolkit/src/redux/util/NotificationHelper';
import {
  FullPageContainer,
  Survey,
} from '@lifeomic/phc-web-toolkit/src/components/Surveys';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';

const questionnaireContextKey =
  contextKeys.patientViewer.fetchConsentQuestionnaire;
const responseContextKey = contextKeys.patientViewer.fetchConsentResposne;

const {
  isFetchingSelector: isFetchingQuestionnaireSelector,
  responsesSelector: questionnaireSelector,
} = bindContextKeyToSelectors(questionnaireContextKey);

const { isFetchingSelector: isFetchingResponseSelector, responsesSelector } =
  bindContextKeyToSelectors(responseContextKey);

const messages = defineMessages({
  loadFailure: {
    id: 'patientViewer.subjectConsent.questionnaire.loadFailure',
    defaultMessage: 'Failed to load the consent content',
  },
  title: {
    id: 'patientViewer.subjectConsent.title',
    defaultMessage: 'Consent',
  },
});

const styles = theme => ({
  loaderContainer: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

class ConsentDetail extends PureComponent {
  componentDidMount() {
    const {
      resetContext,
      fetchQuestionnaire,
      fetchQuestionnaireResponse,
      intl: { formatMessage },
      consent,
    } = this.props;

    if (
      !consent ||
      !consent.questionnaire ||
      !consent.questionnaireResponse ||
      !consent.version
    ) {
      console.error('Unable to load consent details without required data');
      return;
    }

    resetContext(questionnaireContextKey);
    resetContext(responseContextKey);

    const notification = new NotificationHelper(
      null,
      formatMessage(messages.loadFailure),
    );
    fetchQuestionnaire(
      consent.questionnaire,
      {},
      questionnaireContextKey,
      notification,
    );
    fetchQuestionnaireResponse(
      consent.questionnaireResponse,
      {},
      responseContextKey,
      notification,
    );
  }

  render() {
    const {
      isFetching,
      questionnaire,
      response,
      onClose,
      classes,
      intl: { formatMessage },
    } = this.props;

    const contentLoading = isFetching || !questionnaire || !response;

    return (
      <FullPageContainer
        isOpen={true}
        onClose={onClose}
        title={formatMessage(messages.title)}
      >
        {contentLoading ? (
          <div className={classes.loaderContainer}>
            <DotLoader />
          </div>
        ) : (
          <Survey
            isReadOnly={true}
            questionnaireResponse={response}
            questionnaire={questionnaire}
          />
        )}
      </FullPageContainer>
    );
  }
}

ConsentDetail.propTypes = {
  consent: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  resetContext: asyncRequestContextsActions.resetContext,
  fetchQuestionnaire: fhirActions.fetchQuestionnaire,
  fetchQuestionnaireResponse: fhirActions.fetchQuestionnaireResponse,
};

const mapStateToProps = state => ({
  isFetching:
    isFetchingQuestionnaireSelector(state) || isFetchingResponseSelector(state),
  questionnaire: questionnaireSelector(state)[0],
  response: responsesSelector(state)[0],
});

export default compose(
  injectIntl,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(ConsentDetail);
